import { type FooterNamespace } from '../en-US/footer';

export const footer = {
  contact_member_services: 'Contactar Servicios al Miembro',
  copyright: `© ${new Date().getFullYear().toString()} Ministerio de Cuidado Cristiano`,
  disclaimer_body: `Medi-Share es un ministerio de atención médica sin fines de lucro de Christian Care Ministry, Inc ("CCM"). Los miembros de Medi-Share comparten voluntariamente los gastos médicos de los demás de acuerdo con las pautas adoptadas por los miembros y administradas por CCM.
  <br />
  <br />
  Medi-Share no es un seguro y no está regulado como seguro. Ni CCM ni ningún miembro de Medi-Share asumen ninguna obligación legal de compartir el pago de cualquier gasto médico incurrido por otro miembro de Medi-Share. Los miembros de Medi-Share están exentos del mandato individual de la Ley de Protección al Paciente y Atención Médica Asequible. Véase 26 U.S.C §5000 A(d)(2)(B). Ciertos estados eximen expresamente de la regulación de seguros a los ministerios de asistencia sanitaria que, entre otras cosas, publican un aviso específico. Aunque Medi-Share no se basa en dichas exenciones expresas, Medi-Share ha optado por publicar estos avisos. Puede revisar la divulgación requerida para el estado en el que reside: <stateDisclosureLink>KY, MD, PA, WI - All Other States</stateDisclosureLink>.`,
  member_id_cards_button: 'Member ID Cards',
  menu_blog: 'Blog',
  menu_faq: 'Preguntas más frecuentes',
  menu_guideines: 'Pautas',
  menu_national_outreach: 'Alcance Nacional',
  menu_our_ministry: 'Nuestro Ministerio',
  menu_privacy_policy: 'Política de privacidad',
  menu_terms_of_use: 'Condiciones de uso',
  providers_find_button: 'Find Providers',
  quick_links_make_a_share_payment: 'Realizar un Pago de Acciones',
  quick_links_manage_autopay: 'Administrar Pago Automático',
  quick_links_medical_bill_history: 'Historial de Facturas Médicas',
  quick_links_member_forms: 'Formularios de Miembro',
  quick_links_program_summary: 'Resumen del Programa',
  quick_links_schedule_telehealth: 'Programar Telesalud',
  quick_links_share_notices: 'Compartir Avisos',
  quick_links_title: 'Enlaces Rápidos',
  quick_links_your_provider_network: 'Su Red de Proveedores',
  version: 'Versión',
} as const satisfies FooterNamespace;
